document.addEventListener('DOMContentLoaded', function() {
    var chatButton = document.querySelector('#ShopifyChat'); // Finde den Chat-Button
    var body = document.body;

    if (chatButton) {
        console.log('Chat button found');
        initChatButtonBehavior(chatButton);
    } else {
        console.log('Chat button not found');
    }

    function initChatButtonBehavior(chatButton) {
        // Scroll-Überwachung
        document.addEventListener('scroll', function() {
            var scrollPercentage = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
            if (scrollPercentage > 0.9) { // 90% der Seite gescrollt
                chatButton.style.display = 'none'; // Chat-Button ausblenden
                console.log('Chat button hidden');
            } else {
                chatButton.style.display = 'block'; // Chat-Button anzeigen
                console.log('Chat button visible');
            }
        });
    }
});
